import { Maps } from "./maps";

export const GM = {
    markers: [],
    polygon: null,

    init: async () => {
        const containers = document.querySelectorAll('.js-google-map-container');

        if (!containers || containers.length <= 0) return;

        containers.forEach(async (container) => {
            const mapKey = container.dataset.mapKey;
            const markers = window.mapMarkers?.[mapKey] ?? [];
            const markerSize = parseInt(container.dataset.markerSize);
            const zoom = parseInt(container.dataset.zoom);
            const markerImage = container.dataset.markerImage;
            const limitArea = container.dataset.limitArea;
            const centerPoints = String(container.dataset.centerPoints || "false").toLowerCase() === "true";
            const useClusters = String(container.dataset.clusters || "false").toLowerCase() === "true";
            GM.showPopup = String(container.dataset.showPopup || "false").toLowerCase() === "true";

            //await Maps.init(container, limitArea, useClusters);
            const mapInstance = await Maps.createInstance(container, limitArea, useClusters);

            mapInstance.setZoom(zoom);
            //Maps.setCenter(GM.defaultCenter);

            if (GM.showPopup) {
                GM.ensureToastContainer(container);
            }

            markers.forEach(article => {
                //console.log(article);
                if (!article.latitude || !article.longitude) return;

                const icon = {
                    url: markerImage,
                    scaledSize: new google.maps.Size(markerSize / 2, markerSize),
                    anchor: new google.maps.Point(markerSize / 2, markerSize),
                };

                mapInstance.addMarker(
                    { lat: parseFloat(article.latitude), lng: parseFloat(article.longitude) },
                    article.title,
                    icon,
                    GM.showPopup ? () => GM.showToastForArticle(article) : null
                );
            });

            if (centerPoints) mapInstance.fitToMarkers();
        });
    },

    ensureToastContainer: (container) => {
        const wrapper = document.createElement("div");
        wrapper.className = "gm-toast-wrapper position-absolute p-2";
        Object.assign(wrapper.style, {
            top: "0",
            left: "0",
            zIndex: "1000",
        });

        wrapper.innerHTML = `
        <div class="toast bg-white border shadow-sm position-relative"
             role="alert" aria-live="assertive" aria-atomic="true"
             style="min-width:280px;max-width:420px;display:none;opacity:0;transition:opacity .25s ease">
          <button type="button" class="btn-close position-absolute top-0 end-0 m-2" aria-label="Close"></button>
    
          <a class="text-decoration-none gm-toast-link" href="#">
          <div class="d-flex gap-3 p-3 align-items-center">
            <div class="ratio ratio-16x9 rounded overflow-hidden flex-shrink-0" style="width:140px">
              <img class="gm-toast-img w-100 h-100" alt="" style="object-fit:cover;">
            </div>
    
            <div class="flex-grow-1">
              <div class="small text-uppercase text-muted gm-toast-cat mb-1"></div>
              <div class="fw-semibold gm-toast-title mb-1"></div>
            </div>
          </div>
          </a>
        </div>
      `;

        // ancrage map
        container.style.position = container.style.position || "relative";
        container.appendChild(wrapper);

        GM.toastEl    = wrapper.querySelector(".toast");
        GM.toastBody  = GM.toastEl;
        GM.toastImg   = wrapper.querySelector(".gm-toast-img");
        GM.toastCat   = wrapper.querySelector(".gm-toast-cat");
        GM.toastTitle = wrapper.querySelector(".gm-toast-title");
        GM.toastLink  = wrapper.querySelector(".gm-toast-link");

        // close
        wrapper.querySelector(".btn-close").addEventListener("click", () => GM.hideToast());
    },

    showToastForArticle: (article) => {
        if (!GM.toastEl) return;

        const img = article.img || article.image || "";
        const title = article.title || "Sans titre";
        const cat = article.section || article.thematique || article.category || "";
        const url = article.url || "#";

        // fill datas
        if (GM.toastImg) {
            GM.toastImg.src = img;
            GM.toastImg.alt = title;
        }
        if (GM.toastTitle) { GM.toastTitle.textContent = title; }
        if (GM.toastCat)   { GM.toastCat.textContent = cat || ""; GM.toastCat.classList.toggle("d-none", !cat); }
        if (GM.toastLink)  { GM.toastLink.href = url; GM.toastLink.classList.toggle("disabled", !url || url === "#"); }

        // show
        GM.toastEl.style.display = "block";
        requestAnimationFrame(() => { GM.toastEl.style.opacity = "1"; });

        //clearTimeout(GM.toastTimer);
        //GM.toastTimer = setTimeout(() => GM.hideToast(), 4000);
    },

    hideToast: () => {
        if (!GM.toastEl) return;
        GM.toastEl.style.opacity = "0";
        setTimeout(() => {
            GM.toastEl.style.display = "none";
        }, 300);
    }
};

